import { SxProps, Theme } from '@mui/material/styles';
import { FC } from 'react';
import { useQuery } from 'react-query';
import { fetchLocations } from 'src/models/location/location';

import { BaseSelect, SelectProps, createFormSelect } from './BaseSelect';

type LocationSelectProps = Omit<SelectProps, 'options' | 'loading'> & {
  sx?: SxProps<Theme>;
  includeNoLocation?: boolean;
};

export const LocationSelect: FC<LocationSelectProps> = ({
  includeNoLocation = false,
  ...props
}) => {
  const { data: locations, isLoading } = useQuery({
    queryKey: ['locations'],
    queryFn: () => fetchLocations({ fetchAll: true }),
    staleTime: 60000,
    cacheTime: 60000,
    select: (data) => data.locations,
  });

  const options = [
    ...(includeNoLocation ? [{ id: '-1', label: 'No location' }] : []),
    ...(locations?.map((location) => ({
      id: location.id,
      label: location.name,
    })) || []),
  ];

  return <BaseSelect {...props} options={options} loading={isLoading} />;
};

export const FormLocationSelect = createFormSelect(LocationSelect);
